module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    attrs: {
      "id": "admin-filter"
    }
  }, [_c('h4', [_vm._v("Transit Miles filter")]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Origin Location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Origin Location",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.originLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": _vm.selectOrigin
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "form-label"
  }, [_vm._v("Destination Location")]), _vm._v(" "), _c('autocomplete', {
    attrs: {
      "dataset": _vm.locationSearchResults,
      "title": "Origin Location",
      "placeHolder": "Type to search",
      "initVal": _vm.entity.destinationLocation,
      "fnFormatText": _vm.displayLocation,
      "fnSelectValue": _vm.displayLocation
    },
    on: {
      "changing": function (data) { return _vm.locationSearchText = data; },
      "selection-made": _vm.selectDestination
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [_c('div', {
    staticClass: "btn btn-primary sq",
    on: {
      "click": _vm.emitSearch
    }
  }, [_vm._v("\n      Search\n    ")]), _vm._v(" "), _c('div', {
    staticClass: "btn btn-danger sq",
    on: {
      "click": _vm.close
    }
  }, [_vm._v("\n      Cancel\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-076c24e5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modules/admin/components/TransitMile/TransitMileFilter.vue
// module id = 2079
// module chunks = 1